
import "@sparta.sb-credit-cards.modules/engagement-banner-sbcc-module/dist/styles.css"
import "@sparta.sb-credit-cards.modules/product-filter-cc-module/dist/styles.css"
import "@sparta.sb-credit-cards.modules/product-save-return-sbcc-module/dist/styles.css"
import "@sparta.sb-credit-cards.modules/customized-offers-sbcc-module/dist/styles.css"
import "@sparta.sb-credit-cards.modules/banner-content-sbcc-module/dist/styles.css"
import "@sparta.sb-credit-cards.modules/product-overview-information-sbcc-module/dist/styles.css"
import "@sparta.sb-credit-cards.modules/product-overview-content-sbcc-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"

import "@sparta.sb-credit-cards.modules/engagement-banner-sbcc-module/dist/es6.js"
import "@sparta.sb-credit-cards.modules/product-filter-cc-module/dist/es6.js"
import "@sparta.sb-credit-cards.modules/product-save-return-sbcc-module/dist/es6.js"
import "@sparta.sb-credit-cards.modules/customized-offers-sbcc-module/dist/es6.js"
import "@sparta.sb-credit-cards.modules/banner-content-sbcc-module/dist/es6.js"
import "@sparta.sb-credit-cards.modules/product-overview-information-sbcc-module/dist/es6.js"
import "@sparta.sb-credit-cards.modules/product-overview-content-sbcc-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
secureLinkUtility.run()
  console.log('after - execute boot functions')
})();
